import React, {useEffect} from 'react';
import MediaQuery from 'react-responsive';

import mea from '../../services/mea';
import { HeadComponent } from '../HeadComponent';
import HowItWorksComponent from '../HowItWorksComponent';
import ItemCarrouselComponent from '../pages/home/ItemCarrouselComponent';
import CarouselComponent from '../carousel/CarouselComponent';
import PartnerBlockComponent from '../partner/PartnerBlockComponent';

import './Home.scss';

const carouselOptions = {
    dots: false,
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
};

const Authenticated = ({carrouselMeas, onlineOffers, i18nHome = {}, partners, fetchMeasIfNeeded}) => {
    useEffect(() => {
        fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE)
        fetchMeasIfNeeded(mea.constants.ONLINE_OFFER)
    }, [])

    const { TITLE = "", DESCRIPTION = "", MOMENT_SELECTION_TITLE = "" } = i18nHome

    const renderCarouselMeas = () => {
        if (partners && carrouselMeas && carrouselMeas.length > 0) {
            return (
                <section className="accueil-carousel">
                    <CarouselComponent options={carouselOptions}>
                        {carrouselMeas
                            .sort((m1, m2) => m1.ordreAffichage > m2.ordreAffichage)
                            .map((item, i) => {
                                return (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            partners[item.idPartenaire]
                                                ? partners[item.idPartenaire]
                                                : null
                                        }
                                    />
                                );
                            })}
                    </CarouselComponent>
                </section>
            );
        }
    };

    const renderOnlineOffers = () => {
        if (partners && onlineOffers && onlineOffers.length > 0) {
            return (
                <MediaQuery query="(max-width: 768px)">
                    {matches =>
                        matches ? (
                            <React.Fragment>
                                <div className="conteneur-mobile bloc-title">
                                    <h2>{MOMENT_SELECTION_TITLE}</h2>
                                </div>
                                <section className="accueil-carousel">
                                    <CarouselComponent options={carouselOptions}>
                                        {onlineOffers
                                            .filter(mea => partners[mea.idPartenaire])
                                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                                            .slice(0, 4)
                                            .map((item, i) => {
                                                return (
                                                    <ItemCarrouselComponent
                                                        item={item}
                                                        key={i}
                                                        partner={
                                                            partners[item.idPartenaire]
                                                                ? partners[item.idPartenaire]
                                                                : null
                                                        }
                                                        noPicture
                                                    />
                                                );
                                            })}
                                    </CarouselComponent>
                                </section>
                            </React.Fragment>
                        ) : (
                            <section className="selection-mois">
                                <h2>{MOMENT_SELECTION_TITLE}</h2>
                                <div className="grid-4-small-2 has-gutter">
                                    {onlineOffers
                                        .filter(mea => partners[mea.idPartenaire])
                                        .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                                        .slice(0, 4)
                                        .map((item, i) => {
                                            return (
                                                <PartnerBlockComponent
                                                    partner={
                                                        partners[item.idPartenaire]
                                                            ? partners[item.idPartenaire]
                                                            : null
                                                    }
                                                    key={i}
                                                />
                                            );
                                        })}
                                </div>
                            </section>
                        )
                    }
                </MediaQuery>
            );
        }
    };

    return (
        <main className="conteneur" id="p-accueil">
            <div>
                <HeadComponent title={TITLE} description={DESCRIPTION} />
                {renderCarouselMeas()}
                <div className="conteneur-mobile">
                    <HowItWorksComponent showTitle />
                </div>
                {renderOnlineOffers()}
            </div>
        </main>
    );
};

export default Authenticated



// WEBPACK FOOTER //
// ./src/components/home/authenticated.jsx